import { toTestId } from '@panwds/react-utils';
import { tw, twm } from '@panwds/tailwindcss';
import React, {} from 'react';
import { getClassNamesBySizeForCircleShape, getClassNamesBySizeForSquareShape, getOverrideClassName } from './BadgeUtils.js';
const sizes = {
    '2xs': tw `twds-text-2xs`,
    xs: tw `twds-text-xs`,
    sm: tw `twds-text-xs twds-leading-5`,
    md: tw `twds-text-base`,
    lg: tw `twds-text-lg`
};
export function Badge({ children, overrideAppearance, appearance, severity, appearanceStyle = 'solid', dataMetrics, dataTestId, shape = 'square', size = 'xs', as: Component = 'div', textColor = 'light', className, addClassName, getOverrideClassNames }) {
    let badgeClassName;
    if (shape === 'dot') {
        badgeClassName = tw `twds-w-2 twds-h-2 twds-bg-red-500 twds-rounded-full`;
    }
    else {
        badgeClassName =
            className ||
                twm `twds-font-lato twds-inline-block twds-border-none twds-m-0
		${textColor === 'dark' ? '' : tw `twds-text-dark-bg`}
		${sizes[size]}
		${shape === 'square' && getClassNamesBySizeForSquareShape(size)}
		${shape === 'circle' && getClassNamesBySizeForCircleShape(size)}
		${getOverrideClassNames?.() ??
                    getOverrideClassName({
                        severity,
                        appearanceStyle,
                        overrideAppearance,
                        appearance
                    })}
		${addClassName}`;
    }
    return (React.createElement(Component, { "data-metrics": dataMetrics, "data-testid": dataTestId || `badge-${typeof children === 'string' && toTestId(children)}`, className: badgeClassName }, children));
}
//# sourceMappingURL=Badge.js.map